/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    const { project } = feature;
    const INTERFACE = 'current_interface';

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare SNTP_socket as byte
declare SNTP_SERVER as string(16)
`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim SNTP_socket as byte
dim SNTP_SERVER as string(16)
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'SNTP setup
    '================================================================
    SNTP_socket=sock_get("NTP")
    sntp_init()
    SNTP_SERVER=${feature.getSettingValue('SNTP_SERVER')}
    '-----------------------------------------------------------------`,
    });

    blocks.push({
        location: 'on_sock_data_arrival',
        blockType: BlockType.CODE,
        template: '\tsntp_proc_data()',
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: '\tsntp_proc_timer()',
    });

    blocks.push({
        location: 'on_sock_event',
        blockType: BlockType.CODE,
        template: '\tsntp_proc_sock_event(newstate)',
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_sntp_failure',
        template: `
sub callback_sntp_failure(sntp_status as en_sntp_status_codes)
    sys.debugprint("SNTP failed\\r\\n")
    '****callback_sntp_failure****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_sntp_ok',
        template: `
sub callback_sntp_ok(byref w_days as word,byref w_mins as word,byref b_seconds as byte)
    td_gmt_to_local(w_days,w_mins,APP_TIMEZONE,PL_OFF)
    rtc.setdata(w_days,w_mins,b_seconds)
    '****callback_sntp_ok****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_sntp_pre_buffrq',
        template: `
sub callback_sntp_pre_buffrq(required_buff_pages as byte)
    '****callback_sntp_pre_buffrq****'
end sub
        `,
    });

    blocks.push({
        location: project.getNetworkConnectedLocation(INTERFACE),
        blockType: BlockType.CODE,
        template: `
    sntp_start(current_interface,SNTP_SERVER, 0, SNTP_socket)`,
    });

    return blocks;
};
